import React from "react";
import {
    Box,
    Grid,
    Typography,
    Link,
    useTheme,
} from "@mui/material";

const bonuses = [
    "Mother–Child Time Posters",
    "Anger Management Mini Pack",
    "Weekly Routine Planner",
    "Reward Chart to celebrate effort and progress",
];

export default function WhatToExpect() {
    const theme = useTheme();

    return (
        <Box
            component="section"
            sx={{
                py: { xs: 4, md: 8 },
                backgroundColor: "custom.red",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Box
                sx={{
                    maxWidth: 1120,
                    width: "100%",
                    p: { xs: 2, md: 6 },
                }}
            >
                <Typography
                    variant="h3"
                    component="h2"
                    
                    fontWeight={600}
                    fontSize={{ xs: 32, md: 42 }}
                    color="rgba(7, 5, 17, 1)"
                    gutterBottom
                    align="center"
                    sx={{ mb: { xs: 4, md: 6 } }}
                >
                    Here's what to expect:
                </Typography>
                <Grid container spacing={4} alignItems="flex-start">
                    <Grid item xs={12} md={5}>
                        <Box
                            sx={{
                                width: "100%",
                                maxWidth: 450,
                                mx: { xs: "auto", md: 0 },
                            }}
                        >
                            <img
                                src="/assets/cyj-ebook.jpeg"
                                alt="Craft Your Journey eBook"
                                width="100%"
                                style={{ borderRadius: theme.shape.borderRadius }}
                                loading="lazy"
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <Box
                            sx={{
                                fontSize: { xs: 18, md: 20 },
                                color: "rgba(7, 5, 17, 1)",
                                pl: { xs: 1, md: 4 },
                                pr: { xs: 1, md: 2 },
                                py: { xs: 2, md: 3 },
                            }}
                        >
                            <ol style={{ paddingLeft: 24, margin: 0 }}>
                                <li style={{ marginBottom: 20 }}>
                                    You will receive an email shortly with a link to download your eBook. If you have any issues with the download please don't hesitate to reach out to me at{" "}
                                    <Link href="mailto:hello@sarasjournal.com" color="inherit" fontWeight="bold">
                                        hello@sarasjournal.com
                                    </Link>
                                    .
                                </li>
                                <li style={{ marginBottom: 20 }}>
                                    When you get your <em>Happy US</em> eBook today, you’ll also receive <strong>5 Bonuses beautifully designed printable tools</strong> including:
                                    <ul style={{ paddingLeft: 20, marginTop: 10 }}>
                                        {bonuses.map((bonus, idx) => (
                                            <li key={idx} style={{ marginBottom: 8 }}>
                                                <strong>{bonus}</strong>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                                <li style={{ marginBottom: 20 }}>
                                    <strong>Print your favorite pages:</strong> Keep them somewhere you’ll see daily, on the fridge, the kids’ study area, or your bedside.
                                </li>
                                <li style={{ marginBottom: 20 }}>
                                    <strong>Watch the magic unfold:</strong> Within days, you’ll start noticing small shifts, more laughter, fewer power struggles, deeper connection.
                                </li>
                                <li style={{ marginBottom: 0 }}>
                                    <strong>One Last Thing…</strong> You just did something extraordinary. Now go celebrate that, and tonight, when your little one hugs you a little longer, you’ll know why. <strong>Open Your Inbox. Start Your Journey Now.</strong>
                                </li>
                            </ol>
                        </Box>
                    </Grid>
                </Grid>
                {/* Quick Note From Sara */}
                <Box
                    sx={{
                        mt: { xs: 6, md: 8 },
                        background: "#fff",
                        borderRadius: 2,
                        boxShadow: 1,
                        p: { xs: 3, md: 4 },
                        maxWidth: 700,
                        mx: "auto",
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h3"
                        
                        fontWeight={700}
                        fontSize={{ xs: 28, md: 32 }}
                        color="rgba(7, 5, 17, 1)"
                        align="center"
                        sx={{ mb: 2 }}
                    >
                        <strong>A Quick Note From Sara</strong>
                    </Typography>
                    <Typography
                        
                        fontSize={{ xs: 18, md: 20 }}
                        color="rgba(7, 5, 17, 1)"
                        align="center"
                    >
                        You just said <strong>yes </strong>to raising your child with more calm, confidence, and heart.<br />
                        You didn’t buy a book.<br />
                        You invested in moments that will shape how your child feels loved, seen,<br />
                        and safe <strong>for life. </strong>That’s powerful. That’s parenting on purpose.<br /><br />
                        <strong>&mdash; Sara Hafez, MSc in Positive Psychology (UK)</strong>
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
